/**
 * @file: constants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { config } from '@euler/config';
import { storageKeyWrapped } from '@euler/functions/useAsyncStorage';
import { OrgUserRoleType } from '@euler/model/enum';

export const kIdentity = '__identity';
export const kAuthResult = '__auth.result';
export const kAuthProvider = '__auth.provider';
export const kAgentInfo = '__agent_info__';

export const kNullVIN = '00000000000000000';

export const kPrivacyPolicyUrl = 'https://zhichetech.com/privacy-policy.html';
export const kTermsOfServiceUrl = 'https://zhichetech.com/terms-of-use.html';
export const kDefaultTermsOfServiceUrl =
  'https://zhichetech.com/terms-of-service.default.html';

export const kAppStoreSnapshotMode = __DEV__ ? false : false;

export const kPreferredPresentationModeKey =
  config.target + '.preferred_presentation_mode';
export const kAppReviewCoreActionCounterKey = 'app_review.core_action_counter';
export const kVehicleSystemModulesKey = 'vehicle-system-modules';
export const kPreferredColorModeKey = '@euler/settings/color-mode';
export const kAppLaunchCountMetricKey = 'metrics.app.launch_count';
export const kAppLaunchConfigKey = 'app_launch_config';
export const kSavedUserSessionsKey = 'saved_user_sessions';
export const kReportSharingLogsKey = 'report_sharing.logs';

export const kAsyncStorageKeysToPersist = new Set<string>([
  kAgentInfo,
  kPreferredColorModeKey,
  kAppLaunchCountMetricKey,
  kSavedUserSessionsKey,
  storageKeyWrapped(kPreferredPresentationModeKey),
  storageKeyWrapped(kAppReviewCoreActionCounterKey),
  storageKeyWrapped(kAppLaunchConfigKey),
  storageKeyWrapped(kSavedUserSessionsKey),
  storageKeyWrapped(kReportSharingLogsKey),
]);

export const kDefaultMaxElapseTimeInHoursBeforeCanRollback = 24 * 7;
export const kDefaultMaxElapseTimeInDaysBeforeCanUpdateMaintenancePlans = 30;

export const kDefaultOkButtonText = '确定';
export const kDefaultCancelButtonText = '取消';
export const kDefaultConfirmButtonText = '确定';

export const kDefaultRolesAllowedToFinishOrder: OrgUserRoleType[] = [
  OrgUserRoleType.Technicians,
  OrgUserRoleType.ServiceAgents,
  OrgUserRoleType.QualityInspector,
  OrgUserRoleType.Manager,
];
